import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function Lock({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2857 7.77778H13.4286V5.27778C13.4286 2.36806 10.9929 0 8 0C5.00714 0 2.57143 2.36806 2.57143 5.27778V7.77778H1.71429C0.767857 7.77778 0 8.52431 0 9.44444V16.1111C0 17.0312 0.767857 17.7778 1.71429 17.7778H14.2857C15.2321 17.7778 16 17.0312 16 16.1111V9.44444C16 8.52431 15.2321 7.77778 14.2857 7.77778ZM9.42857 13.6111C9.42857 14.3785 8.78929 15 8 15C7.21071 15 6.57143 14.3785 6.57143 13.6111V11.9444C6.57143 11.1771 7.21071 10.5556 8 10.5556C8.78929 10.5556 9.42857 11.1771 9.42857 11.9444V13.6111ZM10.5714 7.77778H5.42857V5.27778C5.42857 3.89931 6.58214 2.77778 8 2.77778C9.41786 2.77778 10.5714 3.89931 10.5714 5.27778V7.77778Z"
        fill={color}
      />
    </svg>
  );
}
